<template>
  <div class="popup" v-if="showModal">
    <div class="popup-body special-scroll special-scroll-dark">
      <h3 class="text-right">תמונות פרופיל</h3>
      <div class="row popup-images">
        <div class="col-6">
          <label>1</label>
          <div class="popup-image-item image-1" id="pick-avatar-1"
               :style='{"background-image":"url(\""+(player.img? player.img:"/img/player.png")+"\")"}'></div>
          <avatar-cropper
              @uploaded="handleUploaded1"
              trigger="#pick-avatar-1"
              upload-url="https://ivote.tv/api/"
              :upload-form-data="{userId:userId}"
              :output-quality="imgQuality"
              :output-options="{width: 400, height: 400}"
              :labels="{ submit: 'אישור', cancel: 'ביטול'}"
          />
        </div>
        <div class="col-6">
          <label>2</label>
          <div class="popup-image-item image-2" id="pick-avatar-2"
               :class="{disabled:!player.img || player.img.includes('img/player.png')}"
               :style='{"background-image":"url(\""+(player.img2? player.img2:"/img/player.png")+"\")"}'></div>
          <span v-show="player.img2" class="remove-image" @click="removeImg2"><i class="fa fa-times"></i></span>
          <avatar-cropper
              @uploaded="handleUploaded2"
              trigger="#pick-avatar-2"
              upload-url="https://ivote.tv/api/"
              :upload-form-data="{userId:userId}"
              :output-quality="imgQuality"
              :output-options="{width: 400, height: 400}"
              :labels="{ submit: 'אישור', cancel: 'ביטול'}"/>
        </div>
      </div>
      <h3 class="text-right">שם המתמודד/ת</h3>
      <input title="שם המתמודד/ת" v-model="player.name" type="text" placeholder="שם מלא">
      <h3 class="text-right">תיאור המתמודד</h3>
      <div class="row">
        <div class="col-4">
          <input title="קבוצה" v-model="player.group" min="1" max="999" type="number" placeholder="קבוצה">
        </div>
        <div class="col-8">
          <input title="שם המתמודד/ת" v-model="player.details" type="text" placeholder="תיאור קצר">
        </div>
        <div class="col-12">
          <p><small>*מצביעים לא יורשו להצביע למתמודדים מאותה הקבוצה.</small></p>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-4">
          <button @click="remove" class="btn btn-danger">הסר</button>
        </div>
        <div class="col-8">
          <button @click="save" class="btn btn-success">שמור וסגור</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper"

export default {
  name: "EditModal",
  props: ['showModal', 'player', "userId", "imgQuality"],
  components: {AvatarCropper},
  data() {
    return {}
  },
  methods: {
    save() {
      if (this.player.img && this.player.img.includes('img/player.png'))
        this.player.img = '';
      if (this.player.img2 && this.player.img2.includes('img/player.png'))
        this.player.img2 = '';
      this.$emit('savePlayer');
    },
    remove() {
      this.$emit('removePlayer');
    },
    removeImg2() {
      this.player.img2 = '';
    },
    handleUploaded1(resp) {
      if (resp.status)
        this.player.img = resp.url;
    },
    handleUploaded2(resp) {
      if (resp.status)
        this.player.img2 = resp.url;
    }
  }
}
</script>

<style scoped lang="scss">


.popup {

  .popup-images {
    direction: rtl;

    label, .remove-image {
      font-weight: bold;
      position: absolute;
      top: 5px;
      padding: 0.25rem .5rem;
      z-index: 10;
    }

    label {
      right: 20px;
    }

    .remove-image {
      left: 30px;
      cursor: pointer;
    }
  }

  .popup-image-item {
    background: white center/cover no-repeat;
    width: 100%;
    border: 1px solid lightgrey;
    border-radius: 10px;
    min-height: 37vw;

    @media (min-width: 768px) {
      min-height: 220px;
    }
  }

  p {
    direction: rtl;
    margin: 0;
  }
}


h3 {
  margin: 20px 0 5px;
}

.disabled {
  pointer-events: none;
  opacity: .75;
}


</style>
